import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HelpdeskNotificationService {
  /** New PNRs detected since last visit to /helpdesk */
  newPnrCount = signal(0);

  clear(): void {
    this.newPnrCount.set(0);
  }

  increment(count: number): void {
    this.newPnrCount.update(n => n + count);
  }
}
